export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10026.a379c968.jpg";